var map = {
	"./btn_ASR_hover.png": "a485",
	"./btn_ASR_normal.png": "7a96",
	"./btn_ASR_pressed.png": "9334",
	"./btn_MT_hover.png": "0f87",
	"./btn_MT_normal.png": "e505",
	"./btn_MT_pressed.png": "d77b",
	"./btn_OCR_hover.png": "7e7a",
	"./btn_OCR_normal.png": "3947",
	"./btn_OCR_pressed.png": "4587",
	"./btn_TA_hover.png": "835c",
	"./btn_TA_normal.png": "f46b",
	"./btn_TA_pressed.png": "edbb",
	"./btn_TTS_hover.png": "f6a8",
	"./btn_TTS_normal.png": "e610",
	"./btn_TTS_pressed.png": "63fb",
	"./btn_meeting_hover.png": "986f",
	"./btn_meeting_normal.png": "bfb9",
	"./btn_meeting_pressed.png": "1bda",
	"./btn_subtitles_hover.png": "659e",
	"./btn_subtitles_normal.png": "9b70",
	"./btn_subtitles_pressed.png": "ffae"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "818c";